// extracted by mini-css-extract-plugin
export default {"sectionFiveCol1":"styles_sectionFiveCol1__zTfgA","sectionFiveContainer":"styles_sectionFiveContainer__yuyVL","sectionFiveCol2":"styles_sectionFiveCol2__bO3fv"};